module.exports = __webpack_public_path__ + "static/media/noun_import_1387515.dc3d3b37.svg";